import Dashboard from '../components/Dashboard';
import { useAuth } from '../AuthContext';
import LandingPage from './LandingPage';

const Home = () => {
  const { user } = useAuth();
  
  const today = new Date().toLocaleDateString(undefined, {
    weekday: 'long', month: 'short', day: 'numeric'
  });

  // 1. What a guest sees (Landing Page)
  if (!user) {
    return (
      <div className="flex flex-col items-center justify-center min-h-[60vh] text-center p-6">
        {/*<h1 className="text-4xl font-extrabold text-gray-900 mb-4">
          Household Hub 🏠
        </h1>
        <p className="text-lg text-gray-600 mb-8 max-w-md">
          The central place for your family's tasks, meals, and calendar. 
          Please sign in to access your dashboard.
        </p>
        */}
        {/* The updated Google Login Button */}
        {/*<button 
          onClick={login}
          className="flex items-center gap-3 bg-white border border-gray-300 text-gray-700 px-6 py-3 rounded-full font-medium hover:bg-gray-50 transition shadow-sm"
        >
          <img 
            src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" 
            alt="Google" 
            className="w-5 h-5"
          />
          Sign in with Google
        </button>*/}
        <LandingPage />
      </div>
    );
  }

  // 2. What a logged-in user sees (Dashboard)
  return (
    <div style={{ padding: '1rem' }}>
      <header className="mb-6">
        <h1 className="text-2xl font-bold">Welcome back, {user.displayName || 'Friend'} 👋</h1>
        <p className="text-gray-500">Today is <strong>{today}</strong></p>
      </header>
      
      <Dashboard />
    </div>
  );
};

export default Home;
